/**
 * The write protection of an inaktiv customer (P6-S6, Stefan's P6 step 22, 7.13): the error words, the
 * events and the reason the nightly run writes when it stops the customer's automations.
 *
 * One German sentence per code (the api, the wizard and the termination answer the same body).
 */
import { formatZurichDateDe } from './zurich-day';

/** A human write on an inaktiv customer: 409 with this body. */
export const CUSTOMER_READ_ONLY = {
  code: 'customer_read_only',
  message: 'Dieser Kunde ist inaktiv und schreibgeschützt.',
} as const;

/** A portal write of an inaktiv customer: 403 with this body (portal errors carry no broker wording). */
export const PORTAL_READ_ONLY = { code: 'portal_read_only' } as const;

/** The reason on everything the nightly run closes for an inaktiv customer (activity, audit, task meta). */
export const KUNDE_INAKTIV_REASON = 'kunde_inaktiv' as const;

export const CUSTOMER_EVENTS = {
  AUTOMATIONS_STOPPED: 'customer.automations_stopped',
} as const;

export const VORGANG_EVENTS = {
  CANCELLED: 'vorgang.cancelled',
} as const;

/** The task a late document of an inaktiv customer raises (meta.kind). */
export const LATE_DOCUMENT_TASK_KIND = 'dokument_nach_inaktivierung' as const;
export const LATE_DOCUMENT_TASK_TITLE = 'Dokument nach Inaktivierung' as const;

/** «inaktiv seit 02.01.2027» from the moment of the run (its Zurich day); legacy rows without it: «inaktiv». */
export function inaktivSeitLabel(inactivatedAt: string | Date | null): string {
  if (inactivatedAt === null) return 'inaktiv';
  const day = formatZurichDateDe(inactivatedAt);
  return day === null ? 'inaktiv' : `inaktiv seit ${day}`;
}
